export const getCurrentNodeToken = () => window.localStorage.getItem('accessNodeToken') ?? undefined;

export const clearNodeToken = () => {
  window.localStorage.setItem('accessNodeToken', '');
};

export const storeNodeToken = (token: string) => {
  window.localStorage.setItem('accessNodeToken', token);
};
